import React, { useMemo } from 'react';
import { ICON } from '../icons/iconIds';
import IconButton from './icons/IconButton';
import Card from './ui/Card';
import Button from './ui/Button';
import DrillHoleMap from './DrillHoleMap';
import './HoleLocationModal.css';

const HoleLocationModal = ({ open, onClose, hole, allHoles }) => {
  const mapData = useMemo(() => {
    if (!allHoles?.length) return [];
    // Filter to holes that have coordinates
    return allHoles.filter(h => h.latitude && h.longitude);
  }, [allHoles]);

  const selectedHoleData = useMemo(() => {
    return mapData.find(h => h.hole_id === hole?.hole_id);
  }, [mapData, hole]);

  if (!open || !selectedHoleData) {
    return null;
  }

  return (
    <div className="modal-overlay hole-location-modal-overlay" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()}>
        <Card className="modal-content hole-location-modal">
          <div className="hole-location-modal__header">
            <div>
              <h3>Hole Location: {hole.hole_id}</h3>
              <p className="hole-location-modal__subtitle">
                {selectedHoleData.prospect && `Prospect: ${selectedHoleData.prospect}`}
              </p>
            </div>
            <IconButton icon={ICON.uiClose} className="close-button" onClick={onClose} ariaLabel="Close" />
          </div>

          <div className="hole-location-modal__map">
            <DrillHoleMap
              data={[selectedHoleData]} // Show only selected hole
              filterType="zone"
              zoneFilters={{}}
              statusFilters={{}}
              showLegend={false}
              smoothZoom
            />
          </div>

          <div className="hole-location-modal__actions">
            <Button onClick={onClose}>Close</Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default HoleLocationModal;
